import { useTheme } from '@mui/material/styles';
import { Typography, Grid } from '@mui/material';
import PageNotFoundImg from '../../../assets/images/PageNotFoundImg.svg';

const NoPagesFound = () => {
    const theme = useTheme();
    return (
        <Grid container justifyContent="center" alignItems="center" height="100vh">
            <Grid>
                <Grid
                    xs={12}
                    sx={{
                        width: 500
                    }}
                >
                    <img src={PageNotFoundImg} alt="" width="100%" />
                </Grid>
                <Grid xs={12} mt={3}>
                    <Typography variant="subtitle1" sx={{ fontSize: '40px', color: theme.palette.grey[700], textAlign: 'center' }}>
                        PAGE NOT FOUND
                    </Typography>
                    <Typography variant="h6" sx={{ fontSize: '20px', color: theme.palette.grey[500], textAlign: 'center', mt: 2 }}>
                        Sorry, we can not find the page you are looking for!
                    </Typography>
                </Grid>
            </Grid>
        </Grid>
    );
};

export default NoPagesFound;
